/* tslint:disable */
/* eslint-disable */
/**
 * Compliance
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const OwnerType = {
    Direct: 'DIRECT',
    Indirect: 'INDIRECT',
    Other: 'OTHER',
    LegalRepresentative: 'LEGAL_REPRESENTATIVE'
} as const;
export type OwnerType = typeof OwnerType[keyof typeof OwnerType];


export function instanceOfOwnerType(value: any): boolean {
    for (const key in OwnerType) {
        if (Object.prototype.hasOwnProperty.call(OwnerType, key)) {
            // @ts-ignore
            if (OwnerType[key] === value) {
                return true;
            }
        }
    }
    return false;
}

export function OwnerTypeFromJSON(json: any): OwnerType {
    return OwnerTypeFromJSONTyped(json, false);
}

export function OwnerTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): OwnerType {
    return json as OwnerType;
}

export function OwnerTypeToJSON(value?: OwnerType | null): any {
    return value as any;
}

